import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }

import HeaderTitleAndDrivingDetail from "@/components/Every24HoursReportPreviewParts/HeaderTitleAndDrivingDetail.vue";
import ChartDetail from "@/components/Every24HoursReportPreviewParts/ChartDetail.vue";
import every24HoursPreviewType from "@/types/responses/every24HoursPreview";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PreviewHeader',
  props: {
    modelValue: {},
    index: {},
    deliveryPlan: {},
    downloading: { type: Boolean },
    chartDetails: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderTitleAndDrivingDetail, {
      deliveryPlan: props.deliveryPlan,
      index: props.index
    }, null, 8, ["deliveryPlan", "index"]),
    _createVNode(ChartDetail, {
      modelValue: modelValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
      index: props.index,
      deliveryPlan: props.deliveryPlan,
      downloading: props.downloading,
      chartDetails: props.chartDetails
    }, null, 8, ["modelValue", "index", "deliveryPlan", "downloading", "chartDetails"])
  ]))
}
}

})